import { render } from "./DeleteLabel.vue?vue&type=template&id=8e385ff2"
import script from "./DeleteLabel.vue?vue&type=script&lang=js"
export * from "./DeleteLabel.vue?vue&type=script&lang=js"

import "./DeleteLabel.vue?vue&type=style&index=0&id=8e385ff2&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__